import { useState, useEffect } from 'react';
import axios from 'axios';

/**
 *
 * @param {*} customerSelectedDate
 * @param {*} seletedOrganizationId
 * @param {*} frequency
 * @returns
 */
function useQueryRevenueData(apiParams) {
  const [responseData, setResponseData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const queryRevenueData = async () => {
      const { selectedDate, organisationId, frequency } = apiParams || {};

      try {
        setIsLoading(false);
        const revenueDataApi = `api/statistics/${organisationId}/invoices`;
        const revenueResponse = await axios.post(revenueDataApi, {
          ...selectedDate,
          frequency,
        });
        const revenueData = revenueResponse.data;
        const sortedRevenueData = revenueData.data.sort((a, b) => a.workrecordId - b.workrecordId);
        setResponseData(sortedRevenueData);
        setError(null);
      } catch (e) {
        setError(e);
        setIsLoading(false);
      }
    };

    queryRevenueData();
  }, [apiParams, axios]);

  return { responseData, isLoading, error };
}

export default useQueryRevenueData;
